[
    {
        "group": "Documentation",
        "itemNumber": "1",
        "clauseId": "Documentation 1",
        "standardRef": "AS/NZS 5139:2019 Clause 6.4.1.2",
        "question": "Has full system manual incorporating all components of AS/NZS 5139:2019 Clause 6.4.1.2, been provided to the home owner?",
        "recommendations": [
            "Battery system information including the below items has not been provided:(i) Total battery storage capacity.(ii) Australian and/or New Zealand address and contact details for the manufacturer’s representative (or deemed equivalent).(iii) UN Number for the battery cell or battery system.(iv) Commissioning date.(v) System provider contact details.",
            "A complete list of installed equipment, with model description and serial numbers has not been included in the documentation.",
            "System performance and operation configuration: system output performance including expected operating response based on programming, expected life of battery system, end of life system parameters and expected operational life. has not been included in the documentation.",
            "A short description of the function and operation of all installed equipment has not been included in the documentation.",
            "Operational instructions for response requirements to battery system or BESS alarms that may be required as part of the installation has not been included in the documentation.",
            "Description and meaning of any state of health measurements, where provided has not been included in the documentation.",
            "Shutdown and isolation procedure for emergency has not been included in the documentation.",
            "Start-up procedure and verification checks has not been included in the documentation.",
            "Description of how to identify when the system is not operating correctly and what to do in the case of a system failure. Details about alarm systems installed as part of the system and in addition to the system have not been included as part of the documentation.",
            "maintenance procedures, a checklist for the installed equipment and schedule for these tasks including hazard mitigation requirements for maintenance tasks. Including shutdown and isolation procedure for maintenance, this may be different to emergency shutdown procedure.",
            "Commissioning records and installation checklist: A record of the initial system settings and firmware version at the time of system installation, verification records, commissioning checklists for quality assurance and date of installation.",
            "System connection diagram: A diagram showing the electrical connections of the battery system with the PCE(s).",
            "Equipment manufacturer’s documentation, data sheets, safety data sheets (SDS) for batteries and handbooks — for all equipment supplied. Where systems have an Ethernet or other form of data interface, include all information on connection requirements and system operating manuals.",
            "A copy of the risk assessment undertaken for Clause 6.2.1 including information on specific requirements to address all risks (for example, the action to take when toxic fumes are present).",
            "Decommissioning information for battery replacement or battery removal including safe handling procedures for the battery system or BESS and recommendations for recycling."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "13",
        "clauseId": "SB & Labelling 13",
        "standardRef": "AS/NZS 4777.1:2024 Clause 5.3.6.4; AS/NZS 3000:2018 amendment 2 Clause 2.6.3.2.5 (a)",
        "question": "Do the alternative supply circuits have appropriate RCD protection?",
        "recommendations": [
            "Alternative supply circuits have been backed up by battery system, altering there source of supply, and RCD protection has not been installed on some/all of the backed-up circuits."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "14",
        "clauseId": "SB & Labelling 14",
        "standardRef": "AS/NZS 4777.1:2024 Clause 8.3.3.2.2 & 8.3.3.3.2.; AS/NZS 3000:2018 Clause 8.3.7.2 (f)",
        "question": "Are there any parallel earth-neutral (secondary MEN) connections present in the battery system/inverter or associated wiring?",
        "recommendations": [
            "A parallel earth-neutral connection has been found on the inverter/battery circuit through testing. AS/NZS 3000 Clause 8.3.7.1 (f)"
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "15",
        "clauseId": "SB & Labelling 15",
        "standardRef": "AS/NZS 4777.1:2024 Clause 5.3.2.2 & 8.3.4.4.2",
        "question": "Is neutral continuity maintained for all circuits provided and operating on an alternative supply?",
        "recommendations": [
            "The alternative supply final sub circuits do not appear to maintain neutral continuity when placed into back up mode."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "21",
        "clauseId": "SB & Labelling 21",
        "standardRef": "AS/NZS 4777.1:2024 Clause 8.4.1 (a);",
        "question": "After turning on the \"MAIN SWITCH(INVERTER)\" does it take greater than 60 seconds for current to be shown on the supplementary supply active conductor?",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "22",
        "clauseId": "SB & Labelling 22",
        "standardRef": "AS/NZS 4777.1:2024 Clause 8.4.1 (b)",
        "question": "After turning off the \"MAIN SWITCH(INVERTER)\" does it take less than 2 seconds for current to dissipate from the supplementary supply active conductor?",
        "recommendations": [
            "Inverter connects to grid within 60s of shutdown and re-energisation. AS/NZS 4777.1 Clause 3.4.4.4, ESGR 2019 Regulation 245 (a)"
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "42",
        "clauseId": "Pre-assembled BS 42",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.1",
        "question": "If the lithium-ion pre-assembled BS has a voltage greater than DVC-A, does all cabling and installation requirements meet the requirements for DVC-C if a non-separated PCE other than an inverter is installed? (e.g., solar charge controller)?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "63",
        "clauseId": "Pre-assembled BS 63",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.4.2",
        "question": "Are the battery system cables flexible cables in accordance with (?): a) AS/NZS 5000.2 (450/750 V insulation) for battery systems with a maximum operating voltage less than 450 V d.c; b) AS/NZS 5000.1 (0.6/1kV insulation) for battery systems with a maximum operation voltage less than 600 V d.c ; or c) IEC 62930 for battery systems with a maximum operating voltage less than 1500 V d.c",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "64",
        "clauseId": "Pre-assembled BS 64",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.4.2",
        "question": "Do the cables between the battery system and the PCE meet the requirements of AS/NZS 3000 for selection and installation of wiring systems? If not, is the defect likely to pose a potential safety risk at some stage in the lifetime of the system?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "65",
        "clauseId": "Pre-assembled BS 65",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.4.2",
        "question": "Do the cables between the battery system and the PCE meet the requirements of AS/NZS 3000 for selection and installation of wiring systems? If not, is the defect not likely to cause a potential safety concern at some stage in the expected lifetime of the system?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "66",
        "clauseId": "Pre-assembled BS 66",
        "standardRef": "AS/NZS 5139 clause 5.3.1.4.2",
        "question": "If the d.c interconnection of the lithium-ion pre-assembled BS to the PCE is not in accordance with AS/NZS 3000, is it such that it constitutes a safety hazard which poses an imminent risk?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "67",
        "clauseId": "Pre-assembled BS 67",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.4.2",
        "question": "Are the cables from the battery system to the PCE: a) double insulated if the battery system's maximum voltage exceeds DVC-A; and b) double insulated for DVC-A battery systems connected to a non-separated PCE (e.g., solar charge controller) and where the non-battery side of the PCE is greater than DCV-A?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "68",
        "clauseId": "Pre-assembled BS 68",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.4.2",
        "question": "For all battery systems operation at DVC-A, are all cables between the battery system, the overcurrent protection device and the PCE double insulated?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "69",
        "clauseId": "Pre-assembled BS 69",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.4.3",
        "question": "Are all cables that exit the pre-assembled BS without internal DC overcurrent protection mechanically protected by at least medium duty conduit or equivalent protection up to the over current device?",
        "recommendations": [
            "Medium duty conduit is required to protect battery cables between battery system and external overcurrent protection device."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "70",
        "clauseId": "Pre-assembled BS 70",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.4.3",
        "question": "For battery systems operating at DVC-B or DVC-C, do the cables between the overcurrent protection device and the PCE have mechanical protection. (Refer to AS/NZS 3000:2018 Cl H4)",
        "recommendations": [
            "For battery systems with voltages above DVC-A, Battery cable mechanical protection must extend all the way from the battery system to the inverter it is connected to."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "71",
        "clauseId": "Pre-assembled BS 71",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.4.4",
        "question": "Is the voltage drop between the battery system and the PCE no more than 2% based on the rated d.c battery port current of the PCE and no more than 5% under any operating conditions?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "72",
        "clauseId": "Pre-assembled BS 72",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.4.5",
        "question": "Is the current-carrying capacity of the pre-assembled battery's system's cable to the overcurrent protection rated to: a) the maximum current rating of the pre-assembled BS; and b) the short-circuit current and duration from the pre-assembled BS.",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "74",
        "clauseId": "Pre-assembled BS 74",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.4.6",
        "question": "If the BESS consists of two or more pre-assembled BS connected in parallel (that do not have a BMS or similar device that provides a managed voltage and current charge/discharge for each separate system), does the output cable from each battery system come to a point where the parallel battery system connects (e.g. PCE or Junction box) have equal cable resistance?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "76",
        "clauseId": "Pre-assembled BS 76",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.5 AS/NZS 3000:2018 Section 3",
        "question": "Does the installation meet the requirements for segregations for a.c and d.c circuits within enclosures from AS/NZS 3000:2018 Section 3?",
        "recommendations": [
            "Due to the installation methods of the AC and DC cables within the duct they do not have suitable segregation."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "77",
        "clauseId": "Pre-assembled BS 77",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.7.3 & AS/NZS 5139:2019 CL 5.3.1.7.4",
        "question": "Where the BS is not directly or resistively earthed to the battery positive or negative conductors and the installation comprises a single BESS with a voltage grater then DVC-A, are all metallic equipment enclosures associated with the BESS installation bonded together to the earthing system of the electrical installation using a minimum bonding conductor size of 6mm2?",
        "recommendations": ["Earth conductor is 4mm not 6mm as required for DVC-B voltage range."]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "78",
        "clauseId": "Pre-assembled BS 78",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.7.1",
        "question": "Is the pre-assembled BS earthed according to manufacturer’s instructions?",
        "recommendations": [
            "Battery storage unit manufacturer specifications show an additional protective earth conductor needs to be connected to the Battery storage unit terminal."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "79",
        "clauseId": "Pre-assembled BS 79",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.6.3",
        "question": "If system is direct earthed (i.e. has an earth been directly connected to the positive or negative battery conductors), is there a conductor connected to the installation earthing system. The pre-assembled battery system earthing conductor shall be rated to withstand the prospective earth fault current of the battery system for a time at least equal to the operating time of the associated overcurrent protective device",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "80",
        "clauseId": "Pre-assembled BS 80",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.6.4",
        "question": "If system is resistively earthed (i.e. has an earth cable has been connected inline with a resistor to the positive or negative battery conductors), is one conductor of the battery system connected to the installation earthing system via a resistor. The pre-assembled battery system earthing conductor shall be rated to withstand the prospective earth fault current of the battery system continuously.",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "81",
        "clauseId": "Pre-assembled BS 81",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.6.5",
        "question": "If system is connected to a non-separated PCE, does it conform with the requirements of AS/NZS 5139:2019 clause 5.3.1.6.5",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "82",
        "clauseId": "Pre-assembled BS 82",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.7.3",
        "question": "If the pre-assembled BS is directly earthed (i.e. has an earth been directly connected to the positive or negative battery conductors) with voltages greater than DVC-A, are all metallic equipment enclosures associated with the pre-assembled BS installation bonded together to the earthing system of the electrical installation using a minimum bonding conductor size of 6mm2 or equivalent to the earth conductor size, whichever is the greater?",
        "recommendations": ["Earth conductor 4mm not 6mm as required."]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "83",
        "clauseId": "Pre-assembled BS 83",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.7.4",
        "question": "If the pre-assembled BS is resistively earthed (i.e. has an earth cable has been connected in line with a resistor to the positive or negative battery conductors) with voltages greater than DVC-A, are all metallic equipment enclosures associated with the pre-assembled BS installation bonded together to the earthing system of the electrical installation using a minimum bonding conductor size of 6mm2 or equivalent to the earth conductor size, whichever is the greater?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "91",
        "clauseId": "Pre-assembled BS 91",
        "standardRef": "AS/NZS 3000",
        "question": "Are there any accessible live parts? Allowing direct contact with any equipment, component, terminals or connection, tested to be LIVE and accessible by 1 action to be touched.",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "92",
        "clauseId": "Pre-assembled BS 92",
        "standardRef": "AS/NZS 3000",
        "question": "Are there connectors, couplings, covers or components able to be removed without the use of a tool which provide access to live parts?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "93",
        "clauseId": "Pre-assembled BS 93",
        "standardRef": "AS/NZS 3000, AS/NZS 5139, AS/NZS 5033, AS/NZS 4777.1",
        "question": "Has all electrical work associated with the installation of the lithium-ion pre-assembled integrated BS been installed in line with Australian standards? If not, is the defect likely to pose a potential safety risk at some stage in the life time of the system?",
        "recommendations": [
            "As per AS/NZS 4777.1 clauses 3.4.1 & 3.3.1 where a multimode inverter is installed the cabling and overcurrent protection must be lifetime line with the larger of the generator input or output."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "94",
        "clauseId": "Pre-assembled BS 94",
        "standardRef": "AS/NZS 3000, AS/NZS 5139, AS/NZS 5033, AS/NZS 4777.1",
        "question": "Has any electrical work associated with the installation of the lithium-ion pre-assembled integrated BESS not been installed in line with Australian standards such that it is not likely to cause a potential safety hazard now or for the expected lifetime of the system?",
        "recommendations": [
            "The neutral conductor for supplementary and/or alternative supplies has not been marked or arranged to indicate the protective device it is associated with. AS/NZS 3000:2018 Clause 2.10.5.4",
            "Each outgoing neutral shall be provided with a separate terminal in the Neutral Bar as per AS/NZS 3000:2018 Clause 2.10.4.3.",
            "Install pole fillers to the DB switchboard so that fingers cannot access live parts without the use of a tool.",
            "The AC connection to the Battery storage Unit has not been installed as per manufacturers installation guidelines. At present a TPS cable is sealed by a single hole gland /inverter plug and therefore may not maintain the IP rating of the Battery storage Unit.",
            "Please Identify corresponding neutral connection e.g. (N.4). Inverter Supply Main Switch shall be marked or arranged to identify the corresponding active and neutral connections for each circuit. (AS/NZS 3000:2018 Cl 2.10.5.4)",
            "AS/NZS3000:2018 Cl 3.10.3.1 – Where conductors or cables, including flexible cables and flexible cords, are to be threaded through conduits, tubes or channels, or passed through openings formed in metalwork, such tubes, channels, conduit ends shall be adequately sized and shall – be provided with bushes that are securely fixed in position; or if not bushed, have no sharp angles or projecting edges that would be likely to damage a conductor2M",
            "Installation methods for conduits entering AC isolator compromise IP rating.",
            "Please arrange the conductors connecting the AC isolator with attention to the retention of stranded conductors at the terminals. The ends of stranded conductors shall be secured by suitable means, as to prevent the spreading or escaping of individual strands. Use of bootlaces is recommended. AS/NZS3000:2018 CL 3.7.2.5.",
            "LV and ELV insulated cables have been installed in close proximity without adequate separation or segregation AS/NZS 3000 Clause 3.9.8.3",
            "The installed gland where cables exit the enclosure and conduit is only suitable for a single cable, reinstall using a gland that is designed for multiple cables.",
            "Please ensure IP rating and mechanical protection of the distribution board adjacent to battery unit is maintained in accordance with AS/NZS 3000:2018 Clauses 4.1.2 & 4.1.3.",
            "Please ensure IP rating and mechanical protection of the AC isolator at the Battery storage Unit is maintained in accordance with AS/NZS 3000:2018 Clauses 4.1.2 & 4.1.3",
            "Install manufactures pips on front cover.",
            "Seal cable entry and the mounting holes at the back of ac isolator.",
            "The enclosure besides the inverter containing multiple protection devices for supplementary and alternative supplies, is classified as a switchboard as per AS/NZS 3000:2018 clause 1.4.121 definition. As such it is required to have a neutral bar provided with separate neutral terminals for each neutral circuit connected in said switchboard as per AS/NZS 3000:2018 Clause 2.10.4.3.",
            "The method of cable support and fixing shall have a lifetime greater than or equal to the service life of the IES. Typically, plastic cable ties exposed to UV will degrade within 2 to 5 years.",
            "3.9.3.3.2 Support and protection Wiring systems installed in positions where they are likely to be disturbed shall be supported at suitable intervals to prevent the undue sagging of cables; and supported to prevent accidental withdrawal of cables from electrical equipment exposing single-insulated conductors; and protected from mechanical damage as specified in Clause 3.3.2.6.",
            "At the AC point of connection plug at inverter double insulation is not maintained all the way into the plug. Therefore, single insulation is exposed. AS/NZS 3000:2018 1.8 & 8.2.2(v), 8.3.3 (b) manufactures installation guidelines."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "95",
        "clauseId": "Pre-assembled BS 95",
        "standardRef": "AS/NZS 3000, AS/NZS 5139, AS/NZS 5033, AS/NZS 4777.1",
        "question": "Has any electrical work associated with the installation of the lithium-ion pre-assembled BS not been installed in line with Australian standards such that it constitutes a safety hazard which poses an imminent risk?",
        "recommendations": [
            "Pre-assembled BS 96 AS/NZS 5139 5.4.2.2)",
            "Are there any loose connections in pre-assembled bs and associated wiring with signs of heat?"
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "96",
        "clauseId": "Pre-assembled BS 96",
        "standardRef": "AS/NZS 5139 5.4.2.2",
        "question": "Are there any loose connections in the pre-assembled BS and associated wiring with no signs of heat?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "97",
        "clauseId": "Pre-assembled BS 97",
        "standardRef": "AS/NZS 5139 5.4.2.2",
        "question": "Are there any loose connections in pre-assembled bs and associated wiring WITH signs of heat?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "99",
        "clauseId": "Pre-assembled BS 99",
        "standardRef": "AS/NZS 5139:2019 clause 5.3.1.6.1",
        "question": "There are four categories relating to the earthing arrangements for battery systems connected to PCEs and each has specific requirements; Please select the appropriate category and inspect to the relevant clause.",
        "recommendations": ["INSTALLATION REQUIREMENTS"]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "4",
        "clauseId": "Pre-assembled BS 4",
        "standardRef": "AS/NZS 5139:2019 CL 5.4.2.3",
        "question": "Are there any signs of alterations or additions that would result in the lithium-ion pre-assembled BS no longer conforming to the Best Practice Guide: Battery Storage Equipment - Electrical Safety Requirements? (https://cleanenergycouncil.org.au/industry-programs/products-program/batteries)",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "5",
        "clauseId": "Pre-assembled BS 5",
        "standardRef": "AS/NZS 5139:2019 CL 5.4.2.3",
        "question": "Are the signs of alterations or additions that make the lithium-ion pre-assembled BS no longer conforming such that it is unsafe?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "22",
        "clauseId": "Pre-assembled BS 22",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.1",
        "question": "Has the lithium-ion pre-assembled BS been installed in accordance with manufacturers installation requirements, including reference to the relevant SDS?",
        "recommendations": [
            "The battery has not been installed in accordance with manufacturer’s instructions in relation to clearance zones. Clearance requirement's is 300mm to sides of battery."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "24",
        "clauseId": "Pre-assembled BS 24",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.2.1 (a) AS/NZS 5139:2019 CL 5.2.5 See line 49",
        "question": "If installed indoors does the location of the lithium-ion pre-assembled integrated BESS allow access to the connections and any serviceable equipment, doors and panels that are required to be accessed for installation and maintenance.",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "25",
        "clauseId": "Pre-assembled BS 25",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.2.1 AS/NZS 3000:2018 Section 6",
        "question": "Does the location of the lithium-ion pre-assembled BS conform to the requirements for damp situations defined by AS/NZS 3000:2018 Section 6?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "38",
        "clauseId": "Pre-assembled BS 38",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.5",
        "question": "If the lithium-ion pre-assembled BS is located in a room, is the room clean, dry and ventilated?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "39",
        "clauseId": "Pre-assembled BS 39",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.5",
        "question": "If the lithium-ion pre-assembled BS is located in a room, does the room provide and maintain protection against detrimental environmental conditions and other external factors?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "40",
        "clauseId": "Pre-assembled BS 40",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.5",
        "question": "If the lithium-ion pre-assembled BS is located in a room, is the room suitable to minimize the likelihood of a build-up insect or vermin infestation or other materials on or around the lithium-ion pre-assembled BS?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "41",
        "clauseId": "Pre-assembled BS 41",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.5",
        "question": "If the lithium-ion pre-assembled BS is located in a room, does the size of the room allow for sufficient clearance around the lithium-ion pre-assembled BS to provide safe handling and access for installation, removal and maintenance? The minimum unimpeded access shall be: a) 900 mm with the doors open b) 600 mm with the doors open for battery systems that have i) voltage no greater than DVC-A; and ii) a calculated arc flash energy at the output terminals of the battery system not greater than 4.0 cal/cm²; or iii) the clearance specified by the manual.",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "84",
        "clauseId": "Pre-assembled BS 84",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.8",
        "question": "Does the lithium-ion pre-assembled BS separated from earth have an alarm system provided that will cause an action to be initiated to correct the fault? This could be audible, visual or via an electronic communication.",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "85",
        "clauseId": "Pre-assembled BS 85",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.2",
        "question": "Has the lithium-ion pre-assembled BS been installed in accordance with manufacturer's instructions to limit the exposure to an arc flash hazard during installation and for maintenance?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "88",
        "clauseId": "Pre-assembled BS 88",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.6 AS/NZS 5139:2019 Table 3.1",
        "question": "Where the lithium-ion pre-assembled BS is categorized as having a explosive gas hazard in AS/NZS 5139:2019 Table 3.1, is the installation in accordance with the instructions of the manufacturer including any venting and containment requirements?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "89",
        "clauseId": "Pre-assembled BS 89",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.7 AS/NZS 5139:2019 Table 3.2",
        "question": "Where the lithium-ion pre-assembled BS is categorized as having a toxic fume hazard in AS/NZS 5139:2019 Table 3.1, is the installation in accordance with the instructions of the manufacturer?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "90",
        "clauseId": "Pre-assembled BS 90",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.8",
        "question": "Does the lithium-ion pre-assembled BS have an alarm system provided that will cause an action to be initiated to correct the fault? This could be audible, visual or via an electronic communication.",
        "recommendations": ["Isolation"]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "11",
        "clauseId": "SB & Labelling 11",
        "standardRef": "AS/NZS 4777.1:2024 clause 5.3.6.2",
        "question": "Have battery/inverter systems utilizing an alternative supply been supplied with an alternative supply main switch in the switchboard they are supplying?",
        "recommendations": [
            "An alternative/back up supply has been connected from the battery system, and a main switch has not been provided at the switchboard that it connects to."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "23",
        "clauseId": "SB & Labelling 23",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.5.3.1",
        "question": "Are there no more than 2 inverter main switches connected to any 1 switchboard with attached loads? There shall be no more than two inverter main switches on a single switchboard with attached loads for all IES connected to that switchboard. Where the number of main switches required on a single switchboard with attached loads is greater than two, a single inverter main switch shall be installed to supply a switchboard without load as per Clause 3.5.3.2.",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "24",
        "clauseId": "SB & Labelling 24",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.5.3.1",
        "question": "Where 2 inverter supplies are connected to a main switchboard or distribution board with other circuits and loads connected, are the inverter main switches grouped together?",
        "recommendations": [
            "Where multiple IES are connected directly to a main switchboard or a distribution board with other circuits and loads, and each has an inverter main switch, then the main switches shall be grouped."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "27",
        "clauseId": "SB & Labelling 27",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.4.1 & 5.3.4",
        "question": "Are circuits that are backed up when the grid is not available grouped?",
        "recommendations": ["Backed up circuits have not been grouped together."]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "33",
        "clauseId": "SB & Labelling 33",
        "standardRef": "AS/NZS 4777.1:2024 Clause 8.4.1 (b)",
        "question": "For systems with alternative supply, is anti-islanding maintained, when \"MAIN SWITCH(GRID)\" is turned off.",
        "recommendations": [
            "Voltage tested on load side of main switch (grid), when in the off position, indicating anti-islanding of multi-mode inverter is not maintained when grid connection is lost."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "17",
        "clauseId": "Pre-assembled BS 17",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.4.3.2 & 5.3.3",
        "question": "If the battery/inverter is not within 3 meters and line of site to the switchboard it is connected, has an AC isolation device/s, that is able to be secured in the open position, been provided adjacent to the battery/inverter to isolate both supplementary and alternative supplies if applicable?",
        "recommendations": [
            "An AC isolation device has not been installed adjacent to the battery system, to isolate the connected alternative supply from the battery system.",
            "An AC isolation device has not been installed adjacent to the battery system, to isolate the connected supplementary supply from the battery system."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "50",
        "clauseId": "Pre-assembled BS 50",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.3.1",
        "question": "Has a means of disconnection been installed to isolate the pre-assembled BS from the PCE and vice versa, to allow for maintenance, repair, fault finding and inspection tasks to be carried out safely?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "51",
        "clauseId": "Pre-assembled BS 51",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.3.2",
        "question": "Is it possible to isolate the PCE from all poles of the pre-assembled BS using one of the following load breaking disconnection methods installed? a) An adjacent and physically separate disconnection device. b) A disconnection device integrated into the PCE. c) A disconnection device integrated into the pre-assembled BS.",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "52",
        "clauseId": "Pre-assembled BS 52",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.3.3",
        "question": "If a switch-disconnector has been used as the load breaking disconnection device, does it meet the following requirements: a) conform to AS 60947.3. b) be of the non-polarized type. c) be d.c rated. d) have a voltage rating than the battery system's maximum voltage under all operating conditions. e) be rated to withstand the maximum short-circuit current. f) have a current rating greater than the maximum d.c current for the BESS. g) be rated to interrupt for full load. h) meet the requirements of AS/NZS 3000:2018 Section 2 for isolating device selection. i) be rated for independent manual operation. j) have a minimum pollution degree 3 classification. k) be able to be secured in the open position and only secured when the main contacts are in the open position; l) conform to requirements for isolation including marking requirements for an isolation device; and m) have a utilization category of at least DC21B.",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "53",
        "clauseId": "Pre-assembled BS 53",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.3.4",
        "question": "If an adjacent or physically separated disconnection device is installed indoors, is the disconnection device mounted in an enclosure that has a minimum IP 23 rating?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "54",
        "clauseId": "Pre-assembled BS 54",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.3.4",
        "question": "If an adjacent or physically separated disconnection device is installed outdoors, is the disconnection device mounted in an enclosure that has a minimum IP 56NW when tested under the conditions of AS 60947.3:2018 Clause D.8.3.13.4, D.8.13.3.5, D.8.3.13.6, D.8.3.13.7 and D.8.3.13.8 (in Australian variations Appendix ZZ)?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "55",
        "clauseId": "Pre-assembled BS 55",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.3.4",
        "question": "Are the switch-disconnectors for outdoor use suitably rated for an ambient temperature of 40 degrees C?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "56",
        "clauseId": "Pre-assembled BS 56",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.3.5",
        "question": "If the disconnection device is integrated in the PCE does it meet one of the following additional requirements: a) An isolation device that is mechanically interlocked with a replaceable module of the PCE, and allows the module to be removed from the section containing the isolation device without risk of electric hazards; or b) An isolation device is located in the same enclosure as the other components of the PCE. With the isolation device in the off position there shall be no risk of electric hazard when any PCE external enclosure cover is removed for repair or replacement of other components of the PCE.",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "57",
        "clauseId": "Pre-assembled BS 57",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.3.6",
        "question": "If the pre-assembled BS includes an internal isolation device operation in all live conductors, is it readily accessible and does it provide the same functions as for an adjacent external isolation device? No additional adjacent external isolation device is required.",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "58",
        "clauseId": "Pre-assembled BS 58",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.3.7",
        "question": "Is the isolation device readily accessible?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "59",
        "clauseId": "Pre-assembled BS 59",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.3.7",
        "question": "Where the cables connecting the pre-assembled BS and PCEs are less than 2m in length, is the isolation device(s) installed adjacent to either the pre-assembled battery system or the PCE?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "60",
        "clauseId": "Pre-assembled BS 60",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.3.7",
        "question": "Where the cables connecting the pre-assembled BS and PCE are greater than 2m in length, is the isolation device installed at both the pre-assembled battery system and PCE?",
        "recommendations": [
            "Please ensure an isolation device installed at both the pre-assembled battery system and PCE."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "61",
        "clauseId": "Pre-assembled BS 61",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.3.8",
        "question": "If there are multiple PCEs (e.g. a solar charge controller and an inverter; or multiple inverters), have separate isolation devices been installed?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "62",
        "clauseId": "Pre-assembled BS 62",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.3.9",
        "question": "If there are two or more lithium-ion pre-assembled battery systems connected in parallel, does each one have a separate isolation device?",
        "recommendations": ["LABELLING"]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "1",
        "clauseId": "SB & Labelling 1",
        "standardRef": "AS/NZS 5139:2019 CL7.3, Appendix B CLB2",
        "question": "Is signage, consisting of circular, green reflector, with the letters \"ES\", installed immediately on or adjacent to the meter box and switchboard, and is readily available to be seen by approaching emergency workers?",
        "recommendations": [
            "The \"ES\" sign has not been placed at the main switchboard as required.",
            "The \"ES\" sign has not been placed at the meter position as required.",
            "The \"ES\" sign is not visible on approach."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "2",
        "clauseId": "SB & Labelling 2",
        "standardRef": "AS/NZ S5139:2019 CL7.3, Appendix B CLB1",
        "question": "Is the ES sign at least 100mm in diameter, and does it contain the United Nations number for the primary chemistry written below the \"ES\" lettering, e.g. UN3480?",
        "recommendations": [
            "ES label is not the required 100mm in diameter as per AS/NZS 5139:2019 CL7.3",
            "Chemistry number UN3480 has not been labelled under the ES lettering as required.",
            "Label has been written with marker exposed to the elements which is not considered permanent."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "3",
        "clauseId": "SB & Labelling 3",
        "standardRef": "AS/NZS 5139:2019 CL7.4, Appendix B example Figure B.2",
        "question": "If the Battery Energy Storage System is not easily located, is there a plan or drawing showing the location of the Battery Energy Storage System located at the main switchboard which includes the location of shutdown procedures?",
        "recommendations": [
            "Battery system is not evident from the main switchboard, and a plan or drawing has not been provided as per AS/NZS 5139 Clause 7.4."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "4",
        "clauseId": "SB & Labelling 4",
        "standardRef": "AS/NZS5139:2019 CL7.6",
        "question": "If the Battery Energy Storage System is located adjacent (i.e. next to or adjoining without obstruction and within arm’s reach) to the switchboard and if multiple battery systems or BESS are installed, is there a sign for each that provides an identifiable number together with the total number of systems installed? For example, BESS 1 of 3?",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "5",
        "clauseId": "SB & Labelling 5",
        "standardRef": "AS/NZS5139:2019 CL7.7",
        "question": "Is there a Safety Data Sheet (hard copy, not digital) installed within a document holder at the main switchboard or meter box?",
        "recommendations": [
            "A physical copy of the battery Safety Data Sheet (SDS) has not been installed within a document holder at the main switchboard or meter box as required."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "6",
        "clauseId": "SB & Labelling 6",
        "standardRef": "AS/NZS 4777.1:2024 Clause 6.3 (b) & (c)",
        "question": "If battery/inverter system is connected to the main switchboard has the grid supply main switch been labelled \"MAIN SWITCH (GRID)” or similar, alternatively if the battery/inverter system has been connected to a distribution board has a sign containing the words \"MAIN ISOLATOR (GRID)” or similar been placed adjacent to the isolator for the normal supply to the distribution switchboard.",
        "recommendations": [
            "The grid supply main switch/isolator has not been labelled at the switchboard to which the battery system is directly connected. Incorrect label displayed."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "8",
        "clauseId": "SB & Labelling 8",
        "standardRef": "AS/NZS 4777.1:2024 Clause 6.3 (a)",
        "question": "Have supplementary supplies been labelled as “MAIN SWITCH (INVERTER)\" at the switchboard to which they are directly connected?",
        "recommendations": [
            "The inverter supplementary supply main switch has not been correctly labelled \"MAIN SWITCH (INVERTER)\". Label reads Main Switch Battery",
            "Where multiple inverters are installed at one installation, does signage accurately reflect which device controls which item of equipment? Inspector recommends re labelling \"MAIN SWITCH INVERTER SUPPLY\" for both inverters to reflect which device they control."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "16",
        "clauseId": "SB & Labelling 16",
        "standardRef": "AS/NZS 4777.1:2024 Clause 6.8",
        "question": "Has a warning label been installed at the main switchboard and all intermediate distribution boards to indicate a multimode inverter with alternative supply has been installed and to follow the shutdown procedure for safe isolation, and is the text \"Neutral and earth circuits may be live under fault conditions\" included on this sign?",
        "recommendations": [
            "An alternative supply has been connected from the battery system/inverter, and the required label has not been placed in the main switchboard and/or any other switchboards energised by the battery system alternative supply.",
            "An alternative supply has been connected from the battery system/inverter, and the required label has not been placed in the Gateway energised by the battery system alternative supply.",
            "An alternative supply has been connected from the battery system/inverter, and the required label has not been placed in the distribution board adjacent to battery storage unit energised by the battery system alternative supply.",
            "At time of inspection an alternative supply had not been commissioned."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "17",
        "clauseId": "SB & Labelling 17",
        "standardRef": "AS/NZS 4777.1:2024 Clause 6.3 (g)",
        "question": "Do switchboards energised by battery system contain the label \"Multiple Supplies Isolate all Supplies before Working on this Switchboard”?",
        "recommendations": [
            "The gateway beside inverter contains multiple protection devices and as such is classified as a switchboard as per AS/NZS 3000:2018 clause 1.4.121 definition. As the switchboard contains multiple supplies it is required to be labelled as per the requirements outlined in section 6 of AS/NZS 4777.1:2024",
            "The gateway contains multiple protection devices and as such is classified as a switchboard as per AS/NZS 3000:2018 clause 1.4.121 definition. As the switchboard contains multiple supplies it is required to be labelled as per the requirements outlined in section 6 of AS/NZS 4777.1:2024",
            "The enclosure adjacent to battery unit contains multiple protection devices and as such is classified as a switchboard as per AS/NZS 3000:2018 clause 1.4.121 definition.",
            "As the switchboard contains multiple supplies it is required to be labelled as per the requirements outlined in section 6 of AS/NZS 4777.1:2024",
            "The sub board with final sub circuits contains multiple supplies it is required to be labelled as per the requirements outlined in section 6 of AS/NZS 4777.1:2024"
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "18",
        "clauseId": "SB & Labelling 18",
        "standardRef": "AS/NZS 4777.1:2024 Clause 6.4",
        "question": "Where the inverter of the battery system is connected to a distribution board, is the following label present on the main switchboard and all intermediate distribution switchboards: “Warning Multiple Supplies Isolate Inverter Supply at Distribution Switchboard at …”?",
        "recommendations": [
            "The battery system has been connected to a distribution board, and the correct label indicating which distribution board the battery system is connected too, has not been installed at the main switchboard."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "19",
        "clauseId": "SB & Labelling 19",
        "standardRef": "AS/NZS 3000 Clause 2.10.5.2; AS/NZS 4777.1:2024 Clause 5.3.6.1",
        "question": "Are circuits that are backed up when the grid is not available appropriately labelled to indicate their function?",
        "recommendations": [
            "Backed up circuits have not been labelled to indicate their function/source of supply.",
            "An attempt has been made to label backed up circuits, but more descriptive wording needs to be used.",
            "An attempt has been made to label backed up circuits, but more descriptive labelling needs to be used as to which devices are baked up.",
            "At time of inspection an alternative supply had not been commissioned."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "25",
        "clauseId": "SB & Labelling 25",
        "standardRef": "AS/NZS 4777.1:2019 Clause 7.2; AS/NZS 4777.1:2024 Clause 6.1",
        "question": "Are all signs and labels - (a) sufficiently durable and designed to have a lifetime greater than or equal to the service life of the battery system or BESS; (b) constructed of durable materials suitable for the location, and where installed exposed to direct sunlight, shall use UV stabilized materials; (c) fixed in a durable manner; (d) in English; (e) legible and in a letter size appropriate for the location (see guidance in Note 1); (f) indelible; and (g) visible, as required, at the installed position.",
        "recommendations": [
            "Hazardous Voltage label has been written in marker pen exposed to UV which is not deemed durable for the lifetime of the system.",
            "Label is starting to peel and is not deemed durable for the lifetime of the system.",
            "Label has fallen off and is not deemed sufficiently fixed for the lifetime of the system.",
            "Label's adjacent to battery storage unit are starting to peel and is not deemed durable for the lifetime of the system.",
            "AC isolator Label is exposed to UV which is not deemed durable for the lifetime of the system."
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "28",
        "clauseId": "SB & Labelling 28",
        "standardRef": "AS/NZS 4777.1:2024 clause 6.3 (d)",
        "question": "Has the main switch for alternative supplies from the battery system/inverter been labelled \"MAIN SWITCH (ALTERNATIVE)\"?",
        "recommendations": [
            "The protection device that the battery system alternative supply is connected to has not been labelled \"MAIN SWITCH (ALTERNATIVE)\" as required.",
            "The protective device for combined supplementary and alternative supply from the battery system has not been labelled \"MAIN SWITCH (ALTERNATIVE)\" as required."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "15",
        "clauseId": "Pre-assembled BS 15",
        "standardRef": "AS/NZS 5139:2019 CL 7.6",
        "question": "Is there a sign adjacent to the lithium-ion pre-assembled BS that states: a) Battery System or Battery Energy Storage System b) The correct Short-circuit current (specifying current in amperes) c) The correct Maximum d.c. voltage (specifying voltage in volts) For systems over DVC-A, the sign shall also state \"\"Hazardous d.c. voltage\"\"",
        "recommendations": [
            "The short-circuit current and or maximum DC voltage rating for the installed battery system/s has not been filled in.",
            "The required label has not been installed at the battery system.",
            "Hazardous DC voltage warning for systems exceeding DVC-A has not been provided.",
            "The required label has not been installed adjacent to the battery system it has been located at main switchboard."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "16",
        "clauseId": "Pre-assembled BS 16",
        "standardRef": "AS/NZS 5139:2019 CL 7.16",
        "question": "Is there a site-specific shutdown procedure that details the sequential steps to safely shutdown the BS? The shutdown procedure shall be a) installed adjacent to the PCE to which the battery system is connected; and b) placed adjacent to and visible from the equipment to be operated in the event of a shutdown. All labelling of devices shall be consistent with terminology used in the shutdown procedure. The shut down procedure shall also state that isolation of the battery system by isolation and shutting down the PCE may not de-energize the battery system and further action may be required.",
        "recommendations": [
            "An alternative AC supply has been connected from the inverter to switchboard and shutdown procedure does not mention how to safely isolate this supply.",
            "An appropriate battery shutdown procedure has not been placed adjacent to the battery storage unit as required.",
            "Shutdown procedure does not mention how to shut down the battery system DC supply.",
            "Battery system DC isolator has not been labelled as per the shutdown procedure.",
            "Battery system AC isolator adjacent to Battery storage unit has not been labelled as per the shutdown procedure.",
            "Some items listed on the shutdown procedure do not align with the labels on electrical isolation equipment located onsite. Please cross reference device labelling with shutdown procedure to ensure there is no confusion.",
            "Step 1 of shutdown procedure does not align with labelling.",
            "Step 2 of the shutdown procedure does not apply with this installation."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "18",
        "clauseId": "Pre-assembled BS 18",
        "standardRef": "AZ/NZS 4777.1:2024 Clause 6.11.1",
        "question": "Where multiple energy sources (e.g. solar and battery) are connected to the one inverter, has a warning sign been installed to indicate all energy sources be turned off to achieve complete isolation? The shutdown procedure shall state “isolation of the battery system by isolation and shutting down the PCE may not de-energise the battery system and further action may be required\" OR \"battery system d.c isolators do not de-energise the battery system and battery system cabling\"",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "19",
        "clauseId": "Pre-assembled BS 19",
        "standardRef": "AS/NZS 5139:2019 Table 3.1 AS/NZS 5139:2019 CL 7.8",
        "question": "If battery chemistry is categorised as a having a risk of battery explosion, has a \"\"Danger, Risk of Battery Explosion\"\" sign been installed in a prominent position approaching the battery system?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "20",
        "clauseId": "Pre-assembled BS 20",
        "standardRef": "AS/NZS 5139:2019 CL 7.9",
        "question": "Is the “Danger, toxic fumes” sign installed adjacent to the enclosure or on all doors to the room where the battery system is located and does it detail the specific fault conditions (e.g. fire) under which the fumes will be present? This sign should also include PPE requirements for entering the room/working with the battery system.",
        "recommendations": [
            "As per AS/NZS 5139 clause 7.9 and table 3.1 all lithium-ion battery systems are required to have a “Danger, toxic fumes” sign installed adjacent to the enclosure or on all doors to the room where the battery system is located."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "21",
        "clauseId": "Pre-assembled BS 21",
        "standardRef": "AS/NZS 5139:2019 CL 7.11",
        "question": "If the battery chemistry is categorised as having an arc flash hazard above \"minor\" (see Table 6.1), is there a sign specifying the dangers of the arc flash? This sign shall be installed either adjacent to the enclosure or on all doors to the room where the battery system is located.",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "98",
        "clauseId": "Pre-assembled BS 98",
        "standardRef": "AS/NZS 5139:2019 Clause 7.14",
        "question": "Has d.c. battery system cabling or enclosures containing battery system cabling between the battery system and inverter been labelled with the word \"BATTERY\" at intervals not exceeding 2m?",
        "recommendations": [
            "Conduit housing battery dc cable between PCE and BS has no labelling.",
            "Conduit housing battery dc cable between PCE and BS requires labels not exceeding required intervals.",
            "Pre-assembled BS 12",
            "Was the lithium-ion pre-assembled BS an approved product on the Clean Energy Councils \"\"Approved battery list\"\" at the time of installation? https://cer.gov.au/document_page/cec-approved-solar-batterieshttps://cleanenergycouncil.org.au/industry-programs/products-program/batteries"
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "12",
        "clauseId": "Pre-assembled BS 12",
        "standardRef": "Source document did not specify a standard reference",
        "question": "Was the lithium-ion pre-assembled BS an approved product on the Clean Energy Council's Approved Battery List at the time of installation?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "13",
        "clauseId": "Pre-assembled BS 13",
        "standardRef": "AS/NZS 5139:2019 CL 5.4",
        "question": "Has the lithium-ion pre-assembled BS been recalled by the manufacturer or regulator?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "23",
        "clauseId": "Pre-assembled BS 23",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.2.1",
        "question": "Has the pre-assembled BS been installed in a location where it is protected from mechanical damage, or has sufficient protection been installed (Such as vehicle bollard/s to prevent damage by impact)? This also includes inappropriate or poorly installed infrastructure aimed at protecting it from mechanical damage.",
        "recommendations": [
            "BS has been installed in a location where it needs to be protected from mechanical damage such as vehicle bollard/s to prevent damage by impact.",
            "Single bollard in its current location does not provide adequate protection against potential battery system side and/or trailing edge impact from vehicles at this installation."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "86",
        "clauseId": "Pre-assembled BS 86",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.3(a)",
        "question": "If mounted on the ground, does the ground appear to be suitable to support the weight of the pre-assembled BS?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "87",
        "clauseId": "Pre-assembled BS 87",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.3(b)",
        "question": "If mounted on a wall or structure, does the wall or structure appear to have the structural integrity to withstand the weight of the pre-assembled BS?",
        "recommendations": ["OVERCURRENT PROTECTION"]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "10",
        "clauseId": "SB & Labelling 10",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.4.2; AS/NZS 3000:2018 Cl 2.5.3.1",
        "question": "Are all cables related to the battery installation, and not covered by other questions in this checklist, protected against overcurrent?",
        "recommendations": [
            "Battery supplementary supply cable is not sufficiently protected by the installed overcurrent protection device"
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "20",
        "clauseId": "SB & Labelling 20",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.4.1 & 5.3.4",
        "question": "Are the inverter/battery supplementary supply cable and associated overcurrent protection device, rated higher than the summation of battery system charging current plus alternative supply overcurrent protection device rating or maximum demand of the alternative supply?",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "29",
        "clauseId": "SB & Labelling 29",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.4.2; AS/NZS 3000:2018 Cl 2.5.3.1",
        "question": "Are all busbars in the installation rated, or protected against potential overcurrent from summation of grid and supplementary supplies? 80amp rated bus bar is not protected against overcurrent from summation of grid and supplementary supplies - Grid and supplementary supplies summation of 85amps.",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "30",
        "clauseId": "SB & Labelling 30",
        "standardRef": "AS/NZS 4777.1:2024 Clause 3.4.2; AS/NZS 3000:2018 Cl 2.5.3.1",
        "question": "Are all cables in the installation rated, or protected against overcurrent from summation of grid and supplementary supplies? 16mm2 feed conductors are not protected against overcurrent summation from grid and supplementary supplies, when 3-way switch is operated in grid supply mode. 10mm2 feed conductors are not protected against overcurrent summation from grid and supplementary supplies, when 3-way switch is operated in grid supply mode. 6mm2 feed conductors are not protected against overcurrent summation from grid and supplementary supplies, when 3-way switch is operated in grid supply mode. 16mm2 conductor feeding multiple final sub circuits, is not protected against overcurrent from summation of grid and supplementary supplies. 10mm2 conductor feeding multiple final sub circuits, is not protected against overcurrent from summation of grid and supplementary supplies. 6mm2 conductor feeding multiple final sub circuits, is not protected against overcurrent from summation of grid and supplementary supplies. 4mm2 conductor feeding multiple final sub circuits, is not protected against overcurrent from summation of grid and supplementary supplies. 2.5mm2 conductor feeding multiple final sub circuits, is not protected against overcurrent from summation of grid and supplementary supplies.",
        "recommendations": []
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "31",
        "clauseId": "SB & Labelling 31",
        "standardRef": "AS/NZS 4777.1:2024 clause 5.3.5.1 AS/NZS 3000:2018 Clause 2.5.3.1",
        "question": "Where required, has overcurrent protection been provided for the alternative supply?",
        "recommendations": [
            "A multi-mode inverter with grid pass-through functionality has been installed, and insufficient overcurrent protection has been installed on the alternative supply cables.",
            "The alternative supply cable does not appear to have been provided with sufficient overcurrent protection."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "43",
        "clauseId": "Pre-assembled BS 43",
        "standardRef": "AS/NZS5139:2019 CL 5.3.1.2.1",
        "question": "Is overcurrent protection installed in all live conductors? Excluding control and monitoring circuits.",
        "recommendations": [
            "As per AS/NZS3000:2018 2.5.1.2 the consumer mains require circuit protection where at present a 100A main isolator has been installed that is wired downstream from the 63amp change over switch."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "44",
        "clauseId": "Pre-assembled BS 44",
        "standardRef": "AS/NZS5139:2019 CL 5.3.1.2.1",
        "question": "if installed, Is the DC overcurrent protection device installed adjacent to the battery system? a) of a non-polarized type. b) d.c. rated c) have a voltage rating greater than the battery system's maximum voltage under all normal and abnormal conditions. d) meet the requirements of AS/NZS 3000:2018 Section 2; and e) have a current rating to protect the cabling from the pre-assembled battery system",
        "recommendations": [
            "DC overcurrent protection is not integrated into the battery; a miniature circuit breaker or HRC fuse has not been installed. The installer must add a compliant HRC fuse or miniature circuit breaker."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "45",
        "clauseId": "Pre-assembled BS 45",
        "standardRef": "AS/NZS5139:2019 CL 5.3.1.2.1",
        "question": "Where a DC overcurrent protective device is not integrated into the lithium-ion pre-assembled BS, has either a HRC fuse or miniature circuit breaker that meet the requirements of AS/NZS 5139:2019 CL 5.3.1.2.1 been installed?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "46",
        "clauseId": "Pre-assembled BS 46",
        "standardRef": "AS/NZS5139:2019 CL 5.3.1.2.1 AS/NZS5139:2019 CL 5.3.1.2.2",
        "question": "If the DC overcurrent protection device is a circuit breaker, does it meet the requirements of AS/NZS 5139:2019 CL 5.3.1.2.2?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "47",
        "clauseId": "Pre-assembled BS 47",
        "standardRef": "AS/NZS5139:2019 CL 5.3.1.2.1 AS/NZS5139:2019 CL 5.3.1.2.3",
        "question": "If the DC overcurrent protection device is a HRC fuse, does it meet the requirements of AS/NZS 5139:2019 CL 5.3.1.2.3?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "48",
        "clauseId": "Pre-assembled BS 48",
        "standardRef": "AS/NZS5139:2019 CL 5.3.1.2.1 AS/NZS5139:2019 CL 5.3.1.2.4",
        "question": "Where the DC overcurrent protective device is integrated into the lithium-ion pre-assembled BS, and is being used to protect the dc. cables between the battery system inverter, does it meet all of the following requirements: - Readily available circuit breaker or HRC fuse, - Operates on both the positive and negative conductors, - Rated lower than the current carrying capacity of the dc cables between the battery system and the inverter, - Permitted by the battery manufacturer to protect the outgoing cables between the battery system and inverter.",
        "recommendations": [
            "Readily available d.c. overcurrent protection in the form of circuit breakers or HRC fuses, complying with AS/NZS 5.3.1.2.4, is not evident at the battery. Please confirm with manufacturer installation guidelines that appropriate protection is present.",
            "If integrated d.c. overcurrent protection does not meet all the requirements of AS/NZS 5139:2019 clause 5.3.1.2.4, then external d.c. overcurrent protection complying with AS/NZS 5139:2019 clause 5.3.1.2.1 will need to be installed to protect the d.c. cabling between the battery system and PCE."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "49",
        "clauseId": "Pre-assembled BS 49",
        "standardRef": "AS/NZS5139:2019 CL 5.3.1.2.5",
        "question": "If the DC overcurrent protection device is external, is it installed as close as practical to the output terminals of the battery system and no greater than 2m away?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "73",
        "clauseId": "Pre-assembled BS 73",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.4.5",
        "question": "Is the current-carrying capacity of the pre-assembled BS cables to the PCE greater than the rating of the overcurrent protection device installed?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "75",
        "clauseId": "Pre-assembled BS 75",
        "standardRef": "AS/NZS 5139:2019 CL 5.3.1.4.7",
        "question": "Has overcurrent protection been installed on the pre-assembled BS's d.c port of the PCE if (?): a) the PCE charging current or load current under fault conditions is greater than the current-carrying capacity of the conductor between the PCE and the pre-assembled BS; and b) the length of the cable between the PCE and the pre-assembled BS overcurrent device is greater than 3m.",
        "recommendations": [
            "The PCE charging current or load current under fault conditions is greater than the current carrying capacity of the conductor between the PCE and the pre-assembled battery system; and",
            "The length of cable between the PCE and the pre-assembled battery system overcurrent protection device is greater than 3 m",
            "PROTECTION FROM FIRE"
        ]
    },
    {
        "group": "SB & Labelling",
        "itemNumber": "26",
        "clauseId": "SB & Labelling 26",
        "standardRef": "AS/NZS 3000:2018 Clause 2.10.7",
        "question": "Do all AC cables related to the battery installation, that pass-through penetrations in the switchboard enclosure, pass through a tight fit (less than 5mm diameter) to reduce the spread of fire?",
        "recommendations": [
            "Penetration in switchboard through which battery/inverter AC cables pass, is larger than 5mm in diameter and has not been sealed to protect against the spread of fire."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "35",
        "clauseId": "Pre-assembled BS 35",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.4.2 AS/NZS 5139:2019 Figure 5.2",
        "question": "If the lithium-ion pre-assembled BS is located on, or placed against the wall, or mounted on the floor within 300mm of the wall or structure separating it from a habitable room, and the surface of the wall is not made of a suitably non-combustible material, has a suitable non-combustible barrier has been placed between the pre-assemble integrated BESS and the surface of the wall or structure to the required dimensions shown in AS/NZS 5139:2019 Figure 4.2?",
        "recommendations": [
            "Fireproofing does not extend on both sides to the minimum required distance"
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "36",
        "clauseId": "Pre-assembled BS 36",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.4.2 AS/NZS 5139:2019 Figure 5.2",
        "question": "Have all penetrations larger than 5mm through non-combustible material separating the battery system from a habitable room, within dimensions shown in AS/NZS 5139:2019 figure 5.2, been filled with a fire-retardant material?",
        "recommendations": [
            "Expansion gap in brickwork within in restricted zone is larger than 5mm in diameter and has not been sealed to protect against the spread of fire. To the left of battery storage unit.",
            "RESTRICTED LOCATIONS"
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "26",
        "clauseId": "Pre-assembled BS 26",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.2.1",
        "question": "If installed in a corridor, hallway or lobby does the lithium-ion pre-assembled BS have at least 1 metre of clearance to allow for safe egress?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "27",
        "clauseId": "Pre-assembled BS 27",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.2.2",
        "question": "Is the pre-assembled integrated BS not installed in any of the the below restricted locations? (a) in restricted locations, as defined for switchboards in AS/NZS 3000; (b) within 600 mm of any exit that has an opening 900mm or less; (c) within 600 mm of any vertical side of a window or building ventilation that ventilates a habitable room; (e) within 900 mm below any of the items included in Items (b), (c); (f) in ceiling spaces; (g) in wall cavities; (h) on roofs, except where specifically deemed suitable; (i) under stairways; (j) under access walkways; or (k) in an evacuation route or escape route (with less than 1m of safe egress)",
        "recommendations": [
            "Battery storage unit has been installed on southern wall 200mm from pedestrian gate which does not completely open due to battery installation.",
            "Battery storage unit has been installed underneath access stairway.",
            "Battery storage unit has been installed on external wall within 500mm of eve that has combustible materials backing onto a habitable room."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "28",
        "clauseId": "Pre-assembled BS 28",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.2.2",
        "question": "Is the lithium-ion pre-assembled BS installed in a habitable room?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "29",
        "clauseId": "Pre-assembled BS 29",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.2.2 AS/NZS 5139:2019 Figure 5.1",
        "question": "Are any fixed appliances not associated with the lithium-ion pre-assembled BS not installed within the restricted zones shown in AS/NZS 5139:2019 Figure 5.1?",
        "recommendations": [
            "Air conditioning unit is within restriction zone - 200mm to the left of battery storage unit."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "30",
        "clauseId": "Pre-assembled BS 30",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.2.2 AS/NZS 60079.14 AS/NZS 3000:2018 Section 7",
        "question": "If the lithium-ion pre-assembled BS installed does not conform to AS/NZS 60079.14, is the installation away from a location defined to be a hazardous area in AS/NZS 3000:2018 Section 7?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "31",
        "clauseId": "Pre-assembled BS 31",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.2.2 AS/NZS 3000:2018 Section 4",
        "question": "Is the lithium-ion pre-assembled BS installed away from hazardous areas for gas cylinders containing heavier-than-air gasses and gas relief vent terminals as defined in AS/NZS 3000:2018 Section 4?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "32",
        "clauseId": "Pre-assembled BS 32",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.3 AS/NZS 5139:2019 CL 5.2.3.2",
        "question": "Is the lithium-ion pre-assembled BS installed in a location that will not expose it to temperatures lower than the minimum or greater than the maximum temperatures as specified by the manufacturer?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "33",
        "clauseId": "Pre-assembled BS 33",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.3 AS/NZS 5139:2019 CL 5.2.3.2",
        "question": "Is the lithium-ion pre-assembled BS installed in a location where it can be protected against damage that might reasonably be expected from the presence of water, high humidity, dust, vermin or direct sunlight?",
        "recommendations": []
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "34",
        "clauseId": "Pre-assembled BS 34",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.3 AS/NZS 5139:2019 CL 5.2.3.2",
        "question": "Is the lithium-ion pre-assembled BS installed in a location that will not expose it to localized or general heat sources? This may include direct sunlight, generators, stream pipes, hot water systems, air conditioners or space heaters. There should also be no direct airflow from any appliance directed at it.",
        "recommendations": [
            "Battery installation manual shows battery unit is not to be installed in direct sunlight – provide appropriate shade cover or relocate.",
            "The Battery unit has not been installed in accordance with manufacturer’s instructions in relation to clearance zones. Clearance requirement's is 350mm to sides of Battery storage unit."
        ]
    },
    {
        "group": "Pre-assembled BS",
        "itemNumber": "37",
        "clauseId": "Pre-assembled BS 37",
        "standardRef": "AS/NZS 5139:2019 CL 5.2.5",
        "question": "If the lithium-ion pre-assembled BS is located in a room, is it located so that access to the battery system is not obstructed by the structure of the building, fixtures and fittings within the room?",
        "recommendations": [
            "General Recommendations",
            "Consent form signed Prior to inspection.",
            "Recalled battery terminal plug appears to be rectified.",
            "Potentially recalled battery and/or inverter found on site. Homeowner has been notified and recommended to contact manufacturer to check if their system is on the list and ensure fixes have been applied where applicable.",
            "Battery system has been installed in a room without a smoke alarm. Inspector recommends the installation of a smoke alarm or heat detector in line with Australian standards and building code recommendations.",
            "Battery system has been installed near combustible materials. AS/NZS 5139:2019 recommends battery systems not be installed near combustible materials.",
            "Battery system alternative supply not tested at time of audit. Unable to test for parallel earth neutral connections, or final sub circuit neutral continuity in backup mode as customer did not wish for grid supply to be interrupted.",
            "Battery system alternative supply not tested at time of audit. Unable to test for parallel earth neutral connections, or final sub circuit neutral continuity in backup mode as battery state of charge was too low to engage Alternate supply.",
            "Alternative supply was not operational at time of inspection, as such multiple MEN, and neutral continuity tests were unable to be performed on backed up circuits.",
            "At the time of the inspection the inspector did not sight all the documentation. As it cannot be denied if the documentation was handed over to the homeowners these items will not be displayed in the final report. It would be advised to review AS/NZS 5139:2019, to confirm if all required documentation was provided to the homeowners.",
            "Inspector noted that existing signage is present from previous installation - Recommend removing old signage to save confusion.",
            "The address listed on REC registry is incorrect. The consent provider has confirmed correct address and has acknowledged this by signing the consent form.",
            "Name on consent form differs from that listed on REC registry.",
            "Type \"AC\" RCD have been installed on final sub circuits supplied by alternative battery supply. Recommend replacing with a type designed to operate when impacted by d.c. waveform. AS/NZS 3000:2018 clause 2.6.2.2.1",
            "Battery system is an expansion to an existing installation, as such parts of the checklist relating to the original/pre-existing installation will not be assessed as part of this audit.",
            "As per AS/NZS3000:2018 2.5.1.2 the consumer mains require circuit protection where at present a main isolator has been installed. As it appears the only works completed by the solar installer is not major works this is a recommendation only.",
            "Hardware onsite differs from what is listed on REC registry. A SigenStor EC 20.0 TP AU has been installed, and REC Registry shows a SigenStor-20T-48 (AS4777-2 2020) has been installed.",
            "Recalled battery terminal plug appears to be rectified",
            "Inspector unable to verify Anti Island test due to installation methods at main switchboard where Alternate supply and Grid supply are switched via double pole circuit breaker.",
            "Inspector could not access sub board in house to confirm labelling or if final sub circuit's had RCD protection. Please ensure sub board complies with current standards.",
            "Distribution board adjacent to battery storage unit had no internal inspection as cover had been silicone on.",
            "Inspector unable to determine if room behind is habitable room, recommend sealing brick breathing holes if habitable room is behind battery storage unit.",
            "Some of the signage at Battery storage unit is not visible on approach due to objects placed to the right. This does not appear to be placed there by installer and is a recommendation to remove objects.",
            "Inspector could not access Meter box as it was pad locked, please ensure labelling and required documents complies with current standards.",
            "Inspector noted that during inspection 2 MENs where observed. As it appears not related to the works completed by the solar/battery installer this is just a note for customer awareness.",
            "As per AS/NZS3000:2018 main switches shall be assessable as follows (a) General Main switches shall be readily accessible and the means of operating such switched shall be not more than two meters above the floor or suitable platform. AS/NZS3000:2018 2.3.3.4",
            "Inspector could not perform internal inspection sub board in Main switch board due to installation methods of conduit entering enclosure, this would require breaking seal around conduit. Please ensure internal components of sub board complies with current standards.",
            "Bottom of Form"
        ]
    }
]
